var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[(!_vm.logged)?_c('Login',{on:{"sucesso":_vm.sucessoLogin}}):_c('Relatorio')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }